export default __webpack_public_path__ + "static/media/database.a6d83729.png";